import ApiService from '../../utils/fetch';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const INVENTORY_ALERT_URL = `${BASE_URL}api/v1/alert/inventory`;

export const fetchInventoryAlerts = async () => {
    const response = await ApiService.get(INVENTORY_ALERT_URL);
    return response.data;
};

export const fetchAlertName = async (category) => {
  console.log('category', category);
  const url = `${BASE_URL}alert/alertNames/${category}`;
  const response = await ApiService.get(url);
 
  return response.data;
};

export const fetchAlertInventory = async ({
 
  category = "",
  exceptionType = "",
  alertName = [],
  periodStartDate = "",
  periodEndDate = ""
} = {}) => {
  const requestBody = {
   
    category,
    exceptionType,
    alertName,
    periodStartDate,
    periodEndDate
  };

  const response = await ApiService.post(
   `${BASE_URL}alert/notifications`,
    requestBody
  );


  return response.data;
};
